const t = String.raw;
export {
  t as tw
};
